import { useAppSelector } from './reduxToolkit'
import { isSubscriptionReadOnly } from '../reduxToolkit/membershipSlice'

/**
 * Hook to check whether the current user has an active subscription or org-based access.
 * Returns { isReadOnly, hasSubscription, subscription } to gate write operations.
 *
 * When isReadOnly is true:
 * - No new expenses can be added
 * - No new incidents can be created
 * - Itemized bill imports are blocked
 * - Users can still close incidents and delete expenses
 */
export function useSubscriptionAccess() {
  const membership = useAppSelector(state => state.membership)
  const isReadOnly = isSubscriptionReadOnly(membership)
  const hasOrganization = !!membership.organization
  const subscription = membership.subscription

  return {
    isReadOnly,
    hasOrganization,
    hasSubscription: !!subscription,
    subscription,
  }
}
